<template>
	<v-bottom-sheet v-model="open" :attach="overlayTarget || undefined" inset class="navigation-app-sheet">
		<v-card>
			<v-card-title class="d-flex align-center ga-2">
				<v-icon>navigation</v-icon>
				{{ t('OpenInApp') }}
				<v-spacer></v-spacer>
				<v-btn icon="close" variant="tonal" color="primary" density="comfortable" @click="open = false" />
			</v-card-title>

			<v-list density="comfortable">
				<v-list-item v-for="app in apps" :key="app.id" :title="app.label" :subtitle="app.subtitle" :disabled="!app.url" @click="launch(app)">
					<template #prepend>
						<v-avatar :image="app.logo" rounded="0" variant="text" />
					</template>
				</v-list-item>
			</v-list>
		</v-card>
	</v-bottom-sheet>
</template>

<script setup>
import { computed, inject } from 'vue';
import { useTranslator } from '@/composables/useTranslator';
import { buildGoogleMapsNavigationUrl, buildWazeNavigationUrl } from '@/utils/domain/navigationUtils';
import googleMapsLogo from '@/assets/img/google-map-icon.svg';
import wazeLogo from '@/assets/img/waze-icon.svg';

const props = defineProps({
	stops: { type: Array, default: () => [] },
});
const open = defineModel({ type: Boolean, default: false });

const t = useTranslator();
const overlayTarget = inject('overlayTarget', null);

const apps = computed(() => {
	const multiStop = props.stops.length > 1;
	return [
		{ id: 'googleMaps', label: 'Google Maps', logo: googleMapsLogo, subtitle: multiStop ? t('SeeAllRoutes') : undefined, url: buildGoogleMapsNavigationUrl(props.stops) },
		{ id: 'waze', label: 'Waze', logo: wazeLogo, subtitle: multiStop ? t('GoToNextAppointment') : undefined, url: buildWazeNavigationUrl(props.stops) },
	];
});

const launch = (app) => {
	window.open(app.url, '_blank');
	open.value = false;
};
</script>
